import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC } from 'react';
import { DialogContent, DialogContentText } from '@mui/material';
import { TConfirmationDialogProps } from './types';

export const ConfirmationDialog: FC<TConfirmationDialogProps> = ({
	open,
	setClose,
	handleConfirm,
	title = '',
	text = '',
	children,
}) => {
	return (
		<Dialog
			open={open}
			onClose={setClose}
			sx={{
				'& .MuiDialog-paper': {
					width: '500px',
					maxWidth: '500px',
					borderRadius: '12px',
				},
			}}
		>
			<DialogTitle color="primary" dangerouslySetInnerHTML={{ __html: title }} />
			<DialogContent>
				<DialogContentText dangerouslySetInnerHTML={{ __html: text }} />
				{children}
			</DialogContent>
			<DialogActions>
				<Button onClick={setClose}>Cancel</Button>
				<Button onClick={handleConfirm} autoFocus>
					Confirm
				</Button>
			</DialogActions>
		</Dialog>
	);
};
